import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MyErrorStateMatcher } from '../../../helpers/error-state-matcher';
import { PasswordValidationModel } from '../../../model/pasword/password-validation.model';
import { TokenValidationResModel } from '../../../model/pasword/token-validation-res.model';
import { AuthService } from '../../../services/auth.service';
import { CaptchaService } from '../../../services/captcha.service';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
  standalone: false
})
export class SetPasswordComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('termsDialog') termsDialog: TemplateRef<any>;

  showPassword: boolean = false;
  passwordEntity = new PasswordValidationModel();
  isSetPasswordSuccess: boolean = false;
  agreedToPolicy: boolean = false;
  setPasswordForm: UntypedFormGroup;
  token: string = null;
  userData: TokenValidationResModel = null;
  isSetPasswordEnabled: boolean = false;
  imagePath = 'bg-0.jpg';
  clearBgTime: any;
  matcher = new MyErrorStateMatcher();
  imgCollection: Array<object> = [
    {
      thumbImage: '/assets/images/login-screen-images/bg-0.jpg',
      alt: 'Image 1'
    }, {
      thumbImage: '/assets/images/login-screen-images/bg-1.jpg',
      alt: 'Image 2'
    }
  ];

  constructor(private authService: AuthService, private fb: UntypedFormBuilder, private router: Router, private route: ActivatedRoute,
              private shareService: SharedService, private toastr: ToastrService,
              private captchaService: CaptchaService) {
    this.authService.cleanTheStorage();
    this.route.queryParams.subscribe(params => {
      this.checkToken(params['token']);
    });
    setInterval(() => {
      this.imagePath = 'bg-' + Math.floor(Math.random() * 2) + '.jpg';
    }, 5000);
  }

  ngAfterViewInit(): void {
    this.captchaService.showCaptchaBanner();
  }

  ngOnDestroy() {
    this.captchaService.hideCaptchaBanner();
    clearTimeout(this.clearBgTime);
  }

  ngOnInit() {
    this.setPasswordForm = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.maxLength(200)]],
      confirmPassword: ['', [Validators.required, Validators.maxLength(200)]]
    }, {validator: this.checkPasswords});
  }

  changeShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  checkPassword(event) {
    if (this.userData) {
      this.passwordEntity.validate(event.target.value);
      this.enableSubmitButton();
    }
  }

  checkToken(token: string) {
    if (!token || token.trim().length < 10) {
      this.router.navigate(['/login']);
    }
    this.token = token;
    this.authService.validateActivationToken(token).subscribe(res => {
      this.userData = res;
      this.setPasswordForm.controls['email'].setValue(res.email);
      this.setPasswordForm.controls['email'].disable();
    }, () => {
      this.toastr.error('Request is invalid!');
      this.router.navigate(['/login']);
    });
  }

  setPassword() {
    if (!this.setPasswordForm.valid) {
      return;
    }
    this.captchaService.getCaptchaToken('set_password').then(captcha => {
      const req = {
        password: this.setPasswordForm.value.password,
        hash: this.userData.hash,
        token: this.token,
        captcha: captcha,
        platform: 'WEB'
      };
      this.authService.setPassword(req).subscribe({
        next: res => {
          if (res.status === 200) {
            this.isSetPasswordSuccess = true;
            this.agreedToPolicy = false;
            this.passwordEntity.isValid = false;
            this.isSetPasswordEnabled = false;
          }
          res.messages.forEach(msg => this.toastr.success(msg));
          res.errors.forEach(e => this.toastr.error(e));
        },
        error: error => {
          this.toastr.error(error.error.description);
        }
      });
    });
  }

  enableSubmitButton() {
    this.isSetPasswordEnabled = (this.setPasswordForm.valid && this.agreedToPolicy && this.passwordEntity.isValid);
  }

  openTermsPrivacyDialog(val) {
    this.shareService.termsPrivacyShow.next(val);
  }

  siteNavigate() {
    window.open('https://countable.co/', '_self');
  }

  private checkPasswords(group: UntypedFormGroup) {
    return group.controls.password.value === group.controls.confirmPassword.value ? null : {notSame: true};
  }
}
